import React, { useEffect, useState } from "react";
import Axios from "../../services/AxiosInstance";

const PartnerList = () => {

  const [partners, setPartners] = useState([]);

  const [selectedPartner, setSelectedPartner] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);

  const [editData, setEditData] = useState({});

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {

      const res = await Axios.get("/api/courses/partners");

      setPartners(sortNewestFirst(res.data));

    } catch (error) {

      console.log("ERROR:", error);

    }
  };

  // Newest partners first using the existing creation timestamp from the
  // API response (VedMG_login.date_time_stamp / added_date, spread via
  // ...loginData). No backend change; missing timestamps sink to the bottom.
  const toTimeMs = (value) => {
    if (!value) return 0;
    if (value instanceof Date) return value.getTime();
    if (typeof value.toDate === "function") {
      try {
        return value.toDate().getTime();
      } catch (e) {
        return 0;
      }
    }
    if (typeof value._seconds === "number") return value._seconds * 1000;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? 0 : d.getTime();
  };

  const getPartnerCreatedMs = (partner) =>
    Math.max(
      toTimeMs(partner?.date_time_stamp),
      toTimeMs(partner?.added_date),
      toTimeMs(partner?.cur_date_time)
    );

  const sortNewestFirst = (list) =>
    Array.isArray(list)
      ? [...list].sort((a, b) => getPartnerCreatedMs(b) - getPartnerCreatedMs(a))
      : list;

  // Blocked partners are highlighted red using the existing
  // VedMG_login.status field (Block => "Inactive", Allow => "Active").
  const isPartnerBlocked = (partner) =>
    String(partner?.status || "").toLowerCase() === "inactive";

  // ALLOW / BLOCK
const updatePartnerStatus = async (userId, status) => {

  // Optimistic update so the clicked row highlights/restores immediately;
  // fetchPartners() below confirms it from the server.
  setPartners((prev) =>
    prev.map((p) =>
      p.loginDocId === userId || p.id === userId
        ? { ...p, status: status }
        : p
    )
  );

  try {

    await Axios.put(
      `/api/courses/update-login-status/${userId}`,
      {
        status: status
      }
    );

    alert(`User ${status} Successfully`);

    fetchPartners();

  } catch (error) {

    console.log("STATUS UPDATE ERROR:", error);

    fetchPartners();

  }
};

const updatePartner = async () => {

try {


const payload = {
  business_name: editData.business_name,
  business_website: editData.business_website,
  business_mobile_no: editData.business_mobile_no,
  business_email_id: editData.business_email_id,
  description: editData.description
};



await Axios.put(
  `/api/courses/partners/${editData.registrationDocId}`,
  payload
);

alert("Partner Updated Successfully");

setShowEditModal(false);

fetchPartners();


} catch (error) {


console.log(
  "UPDATE ERROR =>",
  error.response?.data || error
);

alert(
  error.response?.data?.error ||
  "Update Failed"
);


}

};
  return (
    <div className="container-fluid mt-4">

      {/* Scoped highlight for blocked partners only — no global styles touched */}
      <style>{`
        .partner-blocked-row > td {
          background-color: #dc3545 !important;
          color: #fff !important;
          border-color: #b02a37 !important;
        }
        .partner-blocked-row:hover > td {
          background-color: #c82333 !important;
          color: #fff !important;
        }
        .partner-blocked-row .btn {
          border: 1px solid #fff !important;
        }
        .partner-blocked-row .badge {
          border: 1px solid #fff;
        }
      `}</style>

      <center>
        <h2 className="job-title">PARTNER LIST</h2>
      </center>

      <table className="table table-bordered">

        <thead className="table-dark">
          <tr>
            <th>S.No</th>
            <th>User ID</th>
            <th>Role</th>
            <th>Business Name</th>
            <th>Website</th>
            <th>Mobile No.</th>
            <th>Email Address</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {partners.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                No Partners Found
              </td>
            </tr>
          ) : (
           partners.map((partner, index) => (
  <tr
    key={partner.id}
    className={isPartnerBlocked(partner) ? "partner-blocked-row" : ""}
  >

    <td>{index + 1}</td>

    <td>{partner.user_id}</td>
    <td>
  <span
    className={`badge ${
      partner.role_name === "Admin"
        ? "bg-danger"
        : partner.role_name === "HR"
        ? "bg-success"
        : "bg-primary"
    }`}
  >
    {partner.role_name}
  </span>
</td>

    <td>{partner.business_name}</td>

<td>{partner.business_website}</td>

<td>{partner.business_mobile_no}</td>

<td>{partner.business_email_id}</td>

<td>{partner.description}</td>

    <td>
  <div className="d-flex flex-column action-btns">

    <div className="d-flex mb-1">

      {/* ALLOW BUTTON */}
      <button
  className="btn btn-success btn-sm me-1"
  onClick={() =>
    updatePartnerStatus(
      partner.loginDocId,
      "Active"
    )
  }
>
  Allow
</button>

<button
  className="btn btn-danger btn-sm"
  onClick={() =>
    updatePartnerStatus(
      partner.loginDocId,
      "Inactive"
    )
  }
>
  Block
</button>

    </div>

    <div className="d-flex">

      <button
        className="btn btn-warning btn-sm me-1"
        onClick={() => {
          setEditData(partner);
          setShowEditModal(true);
        }}
      >
        Update
      </button>

      <button
        className="btn btn-info btn-sm"
        onClick={() => {
          setSelectedPartner(partner);
          setShowModal(true);
        }}
      >
        Read
      </button>

    </div>

  </div>
</td>

              </tr>
            ))
          )}

        </tbody>

      </table>

      {/* READ MODAL */}
      {showModal && selectedPartner && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>

          <div style={{
            background: "white",
            padding: "25px",
            borderRadius: "8px",
            width: "400px"
          }}>

            <h4>Partner Details</h4>

            <p>
              <b>Name:</b>
              {" "}
              {selectedPartner.business_name}
            </p>

            <p>
              <b>Website:</b>
              {" "}
              {selectedPartner.business_website}
            </p>

            <p>
  <b>Mobile:</b>{" "}
  {selectedPartner.business_mobile_no}
</p>

            <p>
              <b>Email:</b>
              {" "}
              {selectedPartner.business_email_id}
            </p>

            <p>
              <b>Description:</b>
              {" "}
              {selectedPartner.description}
            </p>

            <button
              className="btn btn-danger mt-2"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>

          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {showEditModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>

          <div style={{
            background: "white",
            padding: "25px",
            borderRadius: "8px",
            width: "400px"
          }}>

            <h4>Edit Partner</h4>

            <input
              className="form-control mb-2"
              value={editData.business_name || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  business_name: e.target.value
                })
              }
            />

            <input
              className="form-control mb-2"
              value={editData.business_website || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  business_website: e.target.value
                })
              }
            />

            <input
  className="form-control mb-2"
  value={editData.business_mobile_no || ""}

onChange={(e) =>
  setEditData({
    ...editData,
    business_mobile_no: e.target.value
  })
}
/>

<input
  className="form-control mb-2"
  value={editData.business_email_id || ""}
  onChange={(e) =>
    setEditData({
      ...editData,
      business_email_id: e.target.value
    })
  }
/>

            <textarea
              className="form-control mb-2"
              value={editData.description || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  description: e.target.value
                })
              }
            />

            <div className="d-flex">

              <button
                className="btn btn-success"
                onClick={updatePartner}
              >
                Update
              </button>

              <button
                className="btn btn-danger ms-2"
                onClick={() => setShowEditModal(false)}
              >
                Close
              </button>

            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default PartnerList;